import { types } from 'mobx-state-tree';

const Service = types.model('Service', {
  id: types.number,
  name: types.string,
  description: types.string,
});

export default Service;
